class NameGenerator {
    constructor() {
        this.groupOne = ['', 'Slayin', 'Sir', 'The', 'Dr.', 'Professor', 'Lord', 'Lady', 'Captain', 'Officer', 'Chief', 'Commander', 'King', 'Queen', 'Prince', "Happy", "Cheerful", "Proud", "Speedy", "Slow", 'Cheeky', 'Cheesy', 'Big', 'Lil', 'Swift', 'Super', 'Vigilant', 'Icy', 'Foggy', 'Slick', 'Sneaky', 'Daring', 'Clever', 'Cool'];
        this.groupTwo = ['', 'Mid', 'Fire', 'Sus', 'Bussin', 'Chopped', 'GOAT', 'Wonder', 'Cooked', 'Amazing','Ranger', "Sasquatch", "Mountain", "River", "Scooter", "Truck",  'Commuter', "Loopy", 'Car', 'Tree', 'Dog', 'Cat', 'Hamster', 'Fish', 'Barnacle', 'Storm', 'Bat',  'Great', 'Sharp', 'Dull', 'Turbo'];
        this.groupThree = ['', 'Diva', 'Glow-Up', 'Sandwich', 'Tangerine', 'Rizz', 'Aura', 'Pants', 'Foot', "Tire", 'Face', 'Driver', 'Boy', 'Girl', 'Dolphin', "Patrol", 'Fighter', 'son', 'Man', 'Woman', 'Nose', 'Guard', 'ington', 'Food', 'Hair', 'Elf', 'Wizard', 'Princess', 'Farmer']
    }

    generateName() {
        this.title = this.groupOne[Math.floor(Math.random() * this.groupOne.length)];
        this.prefix = this.groupTwo[Math.floor(Math.random() * this.groupTwo.length)];
        this.suffix = this.groupThree[Math.floor(Math.random() * this.groupThree.length)];
        let name = `${this.title}${this.prefix}${this.suffix}`;
        if(name.length < 1 || name.length > 18) {
            return this.generateName();
        }else {
            return name;
        }
    }
}

export default NameGenerator;